import { Ng2StateDeclaration } from '@uirouter/angular';
import { ChatComponent } from './chat.component';
import { ChatFeatureComponent } from './chat-feature/chat-feature.component';

export const ChatRoute: Ng2StateDeclaration = {
    name: 'efaactexpert',
    url: '/efaactexpert',
    data: { requiresAuth: true },

    component: ChatFeatureComponent
};
